var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-avatar',_vm._b({attrs:{"alt":_vm.alt,"shape":_vm.shape,"size":_vm.size}},'a-avatar',_vm.additionalProps,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }